import React from 'react';
import IngredientList from './IngredientList';

const DetailView = ({
	img,
	name,
	desc,
	benefits,
	ingredients,
	warnings,
}) => (
	<div className="dish-detail">
		<img src={img} alt={desc} />
		<div className="dish-detail__content">
			<div className="dish-detail__name">{name}</div>
			<div className="dish-detail__description">{desc}</div>			
			{benefits}
			<IngredientList
				ingredients={ingredients || []}
				warnings={warnings || {}} />
			<div className="clearfix" />
		</div>
	</div>
);

export default DetailView;


// WEBPACK FOOTER //
// ./src/detail/DetailView.js